import * as React from 'react';
import { TooltipCommonProps } from '../../common';

export interface HeaderProps {
  /** Any element to be rendered inside under title */
  children?: React.ReactNode;
  /** Define styles through a classname */
  className?: string;
  /** Title */
  title?: React.ReactNode;
  /** Subtitle */
  subtitle?: React.ReactNode;
  /** Tooltip props
   * @linkTypeTo components-overlays--tooltip
   * @setTypeName TooltipCommonProps
   */
  infoTooltipProps?: TooltipCommonProps;
  /** Tooltip content */
  infoTooltipContent?: React.ReactNode;
  /** Show divider */
  showDivider?: boolean;
  /** The number of lines displayed before the text is truncated. */
  maxLines?: number;
  /** When true, text that is longer than it's container will be truncated to a single line followed by ellipsis. Otherwise the text will break into several lines. */
  ellipsis?: boolean;
}
